// ABOUTME: Component to display selected items in bulk mode with ability to remove items
// ABOUTME: Shows list of selected files/folders with metadata and remove functionality

import { Box, CloseIcon, IconButton, Stack, Typography } from '@ds/coolshop';
import React from 'react';
import { useIntl } from 'react-intl';

import type { ISharePointItem } from '../api/types';
import { isSharePointFolder } from '../api/types';
import { getFileTypeLabel } from '../utils/formatters';

type ISelectionSummaryProps = {
    readonly selectedItems: ISharePointItem[];
    readonly onRemoveItem: (item: ISharePointItem) => void;
};

export const SelectionSummary: React.FC<ISelectionSummaryProps> = ({
    selectedItems,
    onRemoveItem,
}) => {
    const intl = useIntl();

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" mb={1}>
                {intl.formatMessage({
                    id: 'sharepoint.selected-items',
                    defaultMessage: 'Elementi Selezionati',
                })}
            </Typography>

            {selectedItems.length === 0 ? (
                <Box
                    height="300px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="4px"
                >
                    <Typography variant="body2" color="text.secondary">
                        {intl.formatMessage({
                            id: 'sharepoint.no-files-selected',
                            defaultMessage: 'Nessun file selezionato',
                        })}
                    </Typography>
                </Box>
            ) : (
                <Box height="300px" overflow="auto" border="1px solid #e0e0e0">
                    {selectedItems.map(item => (
                        <Box
                            display="flex"
                            alignItems="center"
                            key={`${item.driveItemId}-${item.cTagParsed}-${item.name}`}
                            p={1}
                            gap={2}
                        >
                            <IconButton size="small" onClick={() => onRemoveItem(item)}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                            <Stack direction="row" gap={1} alignItems="center">
                                <Box display="flex" gap={2}>
                                    <Typography variant="body2" noWrap flex={1}>
                                        {item.name}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        flexShrink={0}
                                    >
                                        {isSharePointFolder(item)
                                            ? intl.formatMessage({
                                                  id: 'sharepoint.folder',
                                                  defaultMessage: 'Cartella',
                                              })
                                            : getFileTypeLabel(item.name, intl)}
                                    </Typography>
                                    {!isSharePointFolder(item) && item.size && (
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            flexShrink={0}
                                        >
                                            {item.size}
                                        </Typography>
                                    )}
                                </Box>
                                {item.breadcrumbs && item.breadcrumbs.length > 0 && (
                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                        noWrap
                                        flexShrink={0}
                                    >
                                        {item.breadcrumbs.map(crumb => crumb.name).join(' / ')}
                                    </Typography>
                                )}
                            </Stack>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};
